import { Component, OnInit, Injector, forwardRef } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';

import { InputBase } from '@ui/components/form9/base/input-base';

import { inputText9RequiredValidator } from './input-text9.validators';

@Component({
    selector: 'aa-input-text9',
    templateUrl: './input-text9.component.html',
    styleUrls: [
        '../input9.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((): typeof InputText9Component => InputText9Component),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef((): typeof InputText9Component => InputText9Component),
            multi: true,
        }
    ],
    standalone: false
})
export class InputText9Component extends InputBase<string> implements OnInit
{
    private static identifier: number = 0;

    constructor (
        injector: Injector,
        controlContainer: ControlContainer
    )
    {
        super(injector, controlContainer);

        this.fieldId = `idInputText9-${InputText9Component.identifier++}`;
    }

    ngOnInit (): void
    {
        this.initControl(this.required ? [inputText9RequiredValidator(this.customMsg)] : null);
    }
}
